module.exports = __webpack_public_path__ + "media/img/automatic-be614469.svg";